import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, Col, Container, Row} from "reactstrap";
import CropImage from "../reusable/cropImage";
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import {NotificationManager} from "react-notifications";
import Swal from "sweetalert2";

const Artwork = (props) => {
  const history = useHistory();
  const [assessmentInfo, setAssesssmentInfo] = useState({
    assessmentName: "error",
    assessmentFor: "error",
  });
  const [logo, setLogo] = useState(null);
  const [imageError, setImageError] = useState(null);
  const [localImage, setLocalImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [video, setVideo] = useState(null);
  const [localVideo, setLocalVideo] = useState(null);
  const videoInputRef = useRef(null);
  const [userType, setUserType] = useState(props.signedInUser.projectType);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (
      props.userData.eventData?.assessmentName &&
      props.userData.eventData?.assessmentFor
    ) {
      setAssesssmentInfo({
        assessmentName: props.userData.eventData?.assessmentName,
        assessmentFor: props.userData.eventData?.assessmentFor,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Event Lost",
        text: "Kindly Create Event Again",
        confirmButtonText: "Proceed",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/assessment/info");
        }
      });
    }

    if (props.userData.eventData?.companyLogo) {
      setLogo(props.userData.eventData?.companyLogo);
    }
    if (props.userData.eventData?.introVideo) {
      setVideo(props.userData.eventData?.introVideo);
    }
  }, []);

  useEffect(() => {}, [logo]);

  const handleVideoUpload = (e) => {
    if (e.target.files[0].size < 5000000) {
      setVideo(e.target.files[0]);
      setLocalVideo(URL.createObjectURL(e.target.files[0]));
    } else {
      NotificationManager.error("Video must be less than 5mb");
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (logo) {
      const img = await addUrl(logo, "logo");
      let vid;
      if (video) {
        vid = await addUrl(video, "Intro-Video");
      } else {
        vid = "";
      }

      props.setUserData({
        ...props.userData,
        eventData: {
          ...props.userData.eventData,
          companyLogo: img,
          introVideo: vid,
        },
      });
      setLoading(false);
      history.push("/assessment/launch");
    } else {
      setLoading(false);
      console.log(userType, "userType");
      
      userType !== "progress"
          ? NotificationManager.error("Must Upload Logo")
        : NotificationManager.error("Must Upload Logo");
    }
  };
  const previous = () => {
    history.goBack();
  };
  const deleteImage = () => {
    setLogo(null);
    setLocalImage(null);
  };
  const addUrl = async (newFile, type) => {
    const storage = getStorage();
    const eventId = props.userData.eventData?.eventId;

    if (!eventId) {
      throw new Error("Event ID is required for uploading assets");
    }

    if (type === "logo") {
      if (typeof newFile === "string" && !newFile.includes("firebase")) {
        const _file = await urltoFile(
          newFile,
            `${eventId}-logo`,
          "image/png"
        );
        const imageRef = ref(
          storage,
            `eventAssets/${eventId}-logo`
        );
        const data1 = await uploadBytes(imageRef, _file);

        return await getDownloadURL(data1.ref);
      } else {
        return newFile;
      }
    } else if (type === "Intro-Video") {
      if (typeof newFile === "object") {
        const videoRef = ref(
          storage,
            `eventAssets/${eventId}-intro-video`
        );
        const data2 = await uploadBytes(videoRef, newFile);

        return await getDownloadURL(data2.ref);
      } else {
        return newFile;
      }
    }
  };
  const urltoFile = (url, filename, mimeType) => {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  };

  return (
    <Container className="ml-0 right-content-container">
      <Row className="">
        <Col>
          <h1 className="">
            Your{" "}
            <span className="active-text-color text-capitalize">
              {assessmentInfo.assessmentName}{" "}
            </span>
            For{" "}
            <span className="warning-text-color text-capitalize">
              {assessmentInfo.assessmentFor}
            </span>
          </h1>
          <hr className="mb-0 mt-1 heading-hr mx-2" />
        </Col>
      </Row>
      <div>
        <h2 className="active-text-color">Customize Artwork</h2>
        <div className="">
          <div>
            <span className="fs-14">
              Upload company logo {userType !== "progress" && "& Videos"}{" "}
            </span>
            <div className="inner-assessment-content">
              <div style={{ padding: "20px 0" }}>
                <Row>
                  <Col sm={12} lg={6} className="px-4">
                    <div>
                      <label className="art-head">Upload Company Logo*</label>
                      <label
                        role="button"
                        className="input-grey d-flex justify-content-between w-100 p-1 rounded"
                      >
                        <div className="py-2 pl-2">
                          <div className="d-flex">
                            <i
                              className="fa fa-link mt-1 mr-2"
                              aria-hidden="true"
                            />
                            <span
                              className="active-text text-underline"
                              style={{ fontWeight: "600" }}
                            >
                              {logo ? "File Selected" : "Choose file"}
                            </span>
                          </div>
                          <CropImage
                            aspectRatio={1}
                            stateSetImage={setLogo}
                            setError={setImageError}
                            imageLocation="left"
                            setLocal={setLocalImage}
                          />
                        </div>
                        <div
                          className="btn text-white align-items-center"
                          style={{ background: "#fba51b" }}
                        >
                          Upload
                        </div>
                      </label>
                    </div>
                    <span className="fs-12 font-weight-600 text-muted">
                      Logo should be 150 X 150 px, 400 kb size
                    </span>
                  </Col>
                  {/*{userType !== "progress" && (*/}
                    <Col sm={12} lg={6} className="px-4">
                      <div>
                        <label className="art-head">Upload Intro Video</label>
                        <label
                          role="button"
                          className="input-grey d-flex justify-content-between w-100 p-1 rounded"
                        >
                          <div className="py-2 pl-2">
                            <div className="d-flex">
                              <i
                                className="fa fa-link mt-1 mr-2"
                                aria-hidden="true"
                              />
                              <span
                                className="active-text text-underline"
                                style={{ fontWeight: "600" }}
                              >
                                {video ? video.name : "Choose file"}
                              </span>
                            </div>
                            <input
                              type="file"
                              className="d-none"
                              accept="video/mp4,video/x-m4v,video/*"
                              onChange={handleVideoUpload}
                              ref={videoInputRef}
                            />
                          </div>
                          <div
                            className="btn text-white align-items-center"
                            style={{ background: "#fba51b" }}
                          >
                            Upload
                          </div>
                        </label>
                      </div>
                      <span className="fs-12 font-weight-600 text-muted">
                        Video should be 720 x 720 px, 4 mb max size{" "}
                      </span>
                    </Col>
                  {/*)}*/}
                </Row>
                <Row className="mt-3">
                  <Col sm={12} lg={6} className="px-4">
                    {localImage || logo ? (
                      <div className="d-flex align-items-center">
                        <img
                          src={localImage ? localImage : logo && logo}
                          alt=""
                          height={localImage ? 100 : logo ? 100 : 80}
                          width={localImage ? 100 : logo ? 100 : 80}
                        />
                        <div>
                          <Button
                            className="ml-3"
                            color="danger"
                            size="sm"
                            onClick={deleteImage}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col sm={12} lg={6} className="px-4">
                    {localVideo || video ? (
                      <div className="d-flex align-items-center">
                        <video
                          src={localVideo ? localVideo : video && video}
                          width={300}
                          controls
                        />
                        <div>
                          <Button
                            className="ml-3"
                            color="danger"
                            size="sm"
                            onClick={() => {
                              setVideo(null);
                              setLocalVideo(null);
                              videoInputRef.current.value = "";
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="buttons-div">
            <Col sm={12} xs={12} md={6} lg={8}></Col>
            <Col sm={12} xs={12} md={3} lg={2}>
              <Button
                className="previous-button text-white w-100"
                onClick={previous}
                color=""
              >
                Previous
              </Button>
            </Col>
            <Col sm={12} xs={12} md={3} lg={2}>
              <Button
                className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                onClick={handleSubmit}
                disabled={loading}
                color=""
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Loading...</span>
                  </>
                ) : (
                  "Next"
                )}
              </Button>
            </Col>
          </Row>
          {/*<div className="buttons-div">*/}
          {/*    <div className="d-flex align-items-center" role="button">*/}
          {/*        <img src={demoButton} alt="" height={17}/>*/}
          {/*        <span className="text-dark font-weight-600 mx-2">Previous</span>*/}
          {/*    </div>*/}
          {/*    <div className="btn-vr"/>*/}
          {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
          {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
          {/*        <img src={nextBUtton} alt="" height={17}/>*/}
          {/*    </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </Container>
  );
};

export default Artwork;
